// 增强版 Promise.withResolvers polyfill
(function () {
  'use strict'

  // 获取全局对象
  const globalObj = (function () {
    if (typeof globalThis !== 'undefined') {
      return globalThis
    }
    if (typeof self !== 'undefined') {
      return self
    } // Worker 环境
    if (typeof window !== 'undefined') {
      return window
    }
    if (typeof global !== 'undefined') {
      return global
    }
    return this
  })()

  // 确保 Promise 存在
  if (typeof globalObj.Promise === 'undefined') {
    return
  }

  // 如果已经存在，跳过
  if (globalObj.Promise.withResolvers) {
    return
  }

  try {
    // 定义 withResolvers 方法
    globalObj.Promise.withResolvers = function () {
      let resolve, reject
      const promise = new globalObj.Promise((res, rej) => {
        resolve = res
        reject = rej
      })
      return { promise, resolve, reject }
    }
  } catch (error) {
    // 静默失败
    console.warn('无法设置 Promise.withResolvers polyfill')
  }
})()
